import type { QuestionOfFaq } from 'components/Faq';
import type { RestaurantFilterProps } from 'components/RestaurantList';
import { UseCuisinesParams } from 'hooks/use-cuisines';
import type { Gender } from 'templates/Profile';

export const GET_IN_LATITUDE_COOKIE_KEY = 'get-in-latitude';
export const GET_IN_LONGITUDE_COOKIE_KEY = 'get-in-longitude';
export const GET_IN_ADDRESS_COOKIE_KEY = 'get-in-address';
export const GET_IN_AUTH_TOKEN_COOKIE_KEY = 'get-in-token';
export const GET_IN_USER_COOKIE_KEY = 'get-in-user';
export const GET_IN_CITY_COOKIE_KEY = 'get-in-city';
export const GET_IN_ADDRESS_IS_BY_IP_COOKIE_KEY = 'get-in-address-is-by-ip';
export const GET_IN_ANONYMOUS_ID = 'get-in-anonymous-id';

export const STATIC_RESOURCES_BASE_URL =
  process.env.NEXT_PUBLIC_RESOURCES_URL || '';

export const SESSION_EVENT = {
  LOGIN_BY_SMS: 'login_by_sms',
  LOGIN_BY_EMAIL: 'login_by_email',
};

export const PRICE_RANGES: {
  [key: string]: {
    [key: string]: number;
  };
} = {
  $: { upTo: 40 },
  $$: { from: 40, to: 70 },
  $$$: { from: 70, to: 100 },
  $$$$: { above: 100 },
};

export const PRICE_RANGES_TO_NUMBER = {
  $: 1,
  $$: 2,
  $$$: 3,
  $$$$: 4,
};

export const DEFAULT_PARAMS_FOR_RESTAURANTS_REQUESTS: RestaurantFilterProps = {
  service: '',
  distance: 10,
  price_range: '',
  pagination: 1,
  per_page: 20,
  page: 1,
};

export const DEFAULT_PARAMS_FOR_CUISINES_REQUESTS: UseCuisinesParams = {
  pagination: 0,
  sort_direction: 'ASC',
};

export const FAQ_CONTENT: QuestionOfFaq[] = [
  {
    title: 'Como criar uma conta no Get In?',
    description: [
      'É muito fácil fazer um cadastro: você pode fazer o login através de alguma rede social ou informar o seu celular e validá-lo através de um código recebido por mensagem. Caso não receba a mensagem, siga estas instruções:',
      '1. Verifique o sinal da operadora',
      '2. Examine a memória interna do dispositivo',
      '3. Veja se o celular possui alguma atualização disponível',
      '4. Confira o funcionamento do chip',
      '5. Acesse a lista de bloqueio do celular (Os números que enviamos os SMS são: 29090 e 29000)',
      '6. Reinicie o celular',
    ],
  },
  {
    title: 'Como excluir minha conta e/ou meus dados pessoais?',
    description: [
      'Existem 2 formas de excluir sua conta e seus dados armazenados pelo Get In:',
      '1. Envie um e-mail para o nosso Encarregado pelo Tratamento de Dados Pessoais no endereço dpo@getinapp.com.br solicitando a exclusão.',
      'ou',
      '2. Exclua pelo aplicativo Get In, em: “Perfil” -> “Configurações” -> “Excluir minha conta”.',
      'Ao excluir a conta, todos os seus dados pessoais também serão excluídos.',
    ],
  },
  {
    title: 'Como faço uma reserva?',
    description: [
      'As reservas podem ser realizadas via aplicativo ou site Get In.',
      'Selecionando o bar ou restaurante para sua reserva, você escolhe o melhor dia e horário disponível para você!',
    ],
  },
  {
    title: 'É possível acompanhar as minhas reservas futuras?',
    description: [
      'Siiim! :)',
      'Você consegue acompanhar todas as suas reservas direto pelo aplicativo Get In.',
      'Basta acessar o botão de "Minhas Reservas", lá você encontrará todas as suas reservas futuras!',
    ],
  },
  {
    title: 'Como confirmar minha reserva?',
    description: [
      'Além de acompanhar pela página de “Minhas Reservas”, você receberá um e-mail e uma mensagem perto da data da sua reserva para confirmar a sua presença ou cancelar, caso necessário.',
      'Você pode fazer a confirmação direto pelo aplicativo ou site.',
    ],
  },
  {
    title: 'Como alterar minha reserva?',
    description: [
      'Como as datas, horários e quantidade de pessoas dependem exclusivamente da disponibilidade do restaurante, para qualquer alteração na reserva é necessário entrar em contato direto com o estabelecimento, ok?',
      'Caso prefira, você também pode cancelar esta reserva pelo app e buscar a nova data/horário na página do restaurante.',
    ],
  },
  {
    title: 'Posso cancelar uma reserva?',
    description: [
      'Sim! Você pode cancelar a sua reserva direto pelo aplicativo ou site.',
      'Basta acessar a área de "Minhas Reservas", selecionar a reserva que deseja cancelar e efetuar o cancelamento de maneira rápida e fácil.',
      'Confirmando o cancelamento, enviaremos a informação para o restaurante e ela sairá automaticamente do seu perfil e você poderá realizar uma nova reserva, caso queira.',
    ],
  },
  {
    title: 'O que é uma fila remota?',
    description: [
      'Muitos restaurantes disponibilizam a fila remota, ou seja, você pode entrar na fila do restaurante de onde estiver, antes de ir para o restaurante! o/ Demais, né?',
      'Entrando na fila de espera remota pelo Get In, é possível acompanhar a sua posição para se deslocar até o estabelecimento apenas quando estiver chegando a sua vez, assim você não precisa ficar esperando na porta e pode aproveitar esse tempo extra para fazer algo que você goste!',
      'Veja os restaurantes que estão bombando no Get In e não perca tempo, entre na fila agora mesmo! :)',
    ],
  },
  {
    title: 'O que é taxa no-show para pagamento na reserva?',
    description: [
      'Alguns restaurantes Get In possuem a política de taxa de no-show para reserva. Essa política implica no pagamento de uma taxa como garantia da reserva.',
      'Mas fiquem tranquilos, o valor é estornado integralmente no seu cartão de crédito quando o restaurante faz a validação do seu comparecimento na reserva realizada.',
      'Os valores só serão cobrados em casos de não comparecimento ou cancelamento da reserva fora da política de antecedência mínima estabelecida pelo restaurante.',
    ],
  },
  {
    title:
      'Tenho um restaurante e gostaria de cadastrá-lo no Get In. Como faço?',
    description: [
      'Oba! Que boa notícia, vamos adorar ter o seu restaurante como parceiro Get In :)',
      'Você pode entrar em contato com nossa área comercial cadastrando o seu restaurante pelo link abaixo:',
      'https://restaurante.getinapp.com.br/pricing',
    ],
  },
];

export const GENDER_OPTIONS: Gender[] = [
  {
    value: 'male',
    label: 'Masculino',
  },
  {
    value: 'female',
    label: 'Feminino',
  },
  {
    value: 'non-binary',
    label: 'Não Binário',
  },
  {
    value: 'other',
    label: 'Outro',
  },
];

export const notFoundUnitImages: string[] = [
  `${STATIC_RESOURCES_BASE_URL}/b2c/images/notFoundUnitImage1.webp`,
  `${STATIC_RESOURCES_BASE_URL}/b2c/images/notFoundUnitImage2.webp`,
  `${STATIC_RESOURCES_BASE_URL}/b2c/images/notFoundUnitImage3.webp`,
];

export const REGULAR_EXPRESSIONS = {
  wordAndWhiteSpace: /[^\w\s]/gi,
  phoneNumberWithRegionCode: /^(\d{2})(\d{5})(\d{4})$/,
  fullPhoneNumber: /^(\d{2})(\d{2})(\d{5}|\d{4})(\d{4})$/,
  emailRegExp: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
  urlWithHttpOrHttpsProtocolsRequiredRegExp:
    /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/,
};
